import { createContext, useContext } from 'react';

const EditorAsyncPropsContext = createContext({
    isEditMode: false,
    componentsAsyncProps: {},
});

export const EditorAsyncPropsContextProvider = EditorAsyncPropsContext.Provider;
export const useEditorAsyncPropsContext = () => useContext(EditorAsyncPropsContext);
